import classNames from "classnames";

const Interpreter = ({ content = [] }) => {
  function getTag(item, key) {
    switch (item.type) {
      case "h":
        return (
          <h3 key={key} className={classNames("hero-text", item.className)}>
            {item.text}
          </h3>
        );
        break;
      case "p":
        return item.text.map((t, key) => (
          <p key={key} className={classNames("hero-text", item.className)}>
            {t}
          </p>
        ));
        break;
      case "l":
        return (
          <ol key={key} className="list-decimal pl-10">
            {item.text.map((t, key) => (
              <li key={key} className={classNames("hero-text", item.className)}>
                {t}
              </li>
            ))}
          </ol>
        );
      default:
        return (
          <p key={key} className={classNames("hero-text", item.className)}>
            {item.text}
          </p>
        );
        break;
    }
  }
  function getHtml(content) {
    if (
      Array.isArray(content) &&
      content.find((item) => !item.text) === undefined
    ) {
      return content.map((item, key) => getTag(item, key));
    } else {
      return "";
    }
  }
  return getHtml(content);
};

export default Interpreter;
